<template>
  <Header />
  <div class="container mt-4">
    <VideoSection />
    <QuestionsForm />
  </div>
</template>

<script setup>
import Header from '../components/Header.vue';
import VideoSection from '../components/VideoSection.vue';
import QuestionsForm from '../components/QuestionsForm.vue';
</script>
